import { useMemo } from "react";
import useResponsiveValues from "@/components/editor/hooks/useResponsiveValues";
import { DisplayProps } from "./DisplaySettings";
import { DimentionTypes } from "@/components/dimention-field/DimentionField";

const PROPS: (keyof DisplayProps)[] = ["display", "flexDirection", "justifyContent", "alignItems", "gap", "flexGrow"];

const useNormalizeDisplay = (props) => {
  const responsive = useResponsiveValues();

  const draft = useMemo(() => {
    const draft: DisplayProps = {};

    PROPS.forEach((prop) => {
      if (props[prop]) {
        const value = responsive.getValue(props[prop]);

        if (prop === "gap") {
          draft[prop] = value + DimentionTypes.PIXELS;
        } else {
          draft[prop] = value;
        }
      }
    });

    return draft;
  }, [props, responsive]);
  return draft;
};

export default useNormalizeDisplay;
